import React from 'react';

const EmailDraftModal = ({
  isOpen,
  alumni,
  drafts,
  loadingDraftId,
  refiningDraftId,
  sendingDraftId,
  showRefineInput,
  refineInstructions,
  onClose,
  onGenerate,
  onRefine,
  onSend,
  onToggleRefineInput,
  onRefineInstructionsChange,
  onSubjectChange,
  onBodyChange,
  onSubjectBlur,
  onBodyBlur,
}) => {
  if (!isOpen || !alumni) return null;
  const subject = drafts[`${alumni.id}_subject`] ?? alumni.email_subject ?? '';
  const body = drafts[alumni.id] ?? alumni.email_body ?? '';
  const isGenerating = loadingDraftId === alumni.id;
  const isRefining = refiningDraftId === alumni.id;
  const isSending = sendingDraftId === alumni.id;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-[#242831] rounded-lg w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b border-[#374151]">
          <h2 className="text-2xl font-bold text-[#e4e6eb]">Draft Email</h2>
          <button onClick={onClose} className="text-[#9ca3af] hover:text-[#e4e6eb] transition-colors text-3xl leading-none">
            ×
          </button>
        </div>
        <div className="p-6">
          <div className="bg-[#2d3139] rounded-lg p-6 mb-6 grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: 'Name', value: alumni.alumni_name },
              { label: 'Position', value: alumni.alumni_position },
              { label: 'Company', value: alumni.alumni_company },
              { label: 'Email', value: alumni.alumni_email },
            ].map(info => (
              <div key={info.label}>
                <div className="text-xs text-[#9ca3af] uppercase tracking-wider mb-1">{info.label}</div>
                <div className="text-[#e4e6eb] font-medium">{info.value || 'N/A'}</div>
              </div>
            ))}
          </div>
          <div className="mb-6">
            <div className="text-base font-semibold text-[#e4e6eb] mb-3">Generate Email with AI</div>
            <button
              onClick={() => onGenerate(alumni)}
              disabled={isGenerating}
              className="px-6 py-3 bg-[#10b981] text-white rounded-lg hover:bg-[#059669] transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-semibold flex items-center gap-2"
            >
              {isGenerating ? (
                <>
                  <span className="animate-spin inline-block w-4 h-4 border-2 border-t-transparent border-white rounded-full" />
                  Generating...
                </>
              ) : (
                <>Generate Email</>
              )}
            </button>
          </div>
          <div>
            <div className="text-base font-semibold text-[#e4e6eb] mb-3">Email Draft</div>
            <input
              type="text"
              placeholder="Subject"
              value={subject}
              onChange={e => onSubjectChange(alumni.id, e.target.value)}
              onBlur={e => onSubjectBlur(alumni, e.target.value)}
              className="w-full bg-[#2d3139] border border-[#374151] rounded-lg px-4 py-3 mb-4 text-[#e4e6eb] placeholder-[#9ca3af] focus:outline-none focus:border-[#10b981]"
            />
            <textarea
              rows={10}
              placeholder="Write your message..."
              value={body}
              onChange={e => onBodyChange(alumni.id, e.target.value)}
              onBlur={e => onBodyBlur(alumni, e.target.value)}
              className="w-full bg-[#2d3139] border border-[#374151] rounded-lg px-4 py-3 text-[#e4e6eb] placeholder-[#9ca3af] focus:outline-none focus:border-[#10b981]"
            />
            <div className="mt-4 space-y-4">
              <button
                onClick={() => onToggleRefineInput(alumni.id)}
                className="text-[#10b981] text-sm font-semibold hover:text-[#059669] transition-colors"
              >
                ✨ Refine this email
              </button>
              {showRefineInput[alumni.id] && (
                <div className="bg-[#2d3139] rounded-lg p-4 border border-[#374151] space-y-3">
                  <textarea
                    rows={3}
                    placeholder="Add instructions for how you'd like to refine this email..."
                    value={refineInstructions[alumni.id] || ''}
                    onChange={e => onRefineInstructionsChange(alumni.id, e.target.value)}
                    className="w-full bg-[#23242a] border border-[#374151] rounded-lg px-3 py-2 text-sm text-[#e4e6eb] placeholder-[#9ca3af] focus:outline-none focus:border-[#10b981]"
                  />
                  <div className="flex gap-2 justify-end">
                    <button
                      onClick={() => onToggleRefineInput(alumni.id)}
                      className="px-4 py-2 text-sm text-[#9ca3af] hover:text-[#e4e6eb] transition-colors"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => onRefine(alumni)}
                      disabled={isRefining}
                      className="px-4 py-2 bg-[#10b981] text-white rounded-lg text-sm font-semibold hover:bg-[#059669] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isRefining ? 'Refining...' : 'Apply Instructions'}
                    </button>
                  </div>
                </div>
              )}
              <button
                onClick={() => onSend(alumni)}
                disabled={isSending}
                className="w-full bg-[#10b981] text-white py-3 rounded-lg font-semibold hover:bg-[#059669] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSending ? 'Sending...' : 'Send Email'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { EmailDraftModal };
